<template>
	<div class="topbar">
		<div class="leftbox">
			<div  v-if='htmlon==2' class="addApp" @click='showTemp=true'>
				<svg-icon class='ico' icon-class='add'/>
				<span>创建小程序</span>
			</div>
			<div class="dropbox" v-else>
				<el-dropdown @command="commandClick" :show-timeout='0' >
					<span class="btnleft">
						<span style='margin-left: 10px;cursor: pointer;line-height: 50px;' >{{htmlon==0? "设计小程序" : htmlon==1? "管理小程序":"平台首页"}}</span>
						<svg-icon class='bottom' style='margin-left: 10px' icon-class='bottom' />
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command='home'>
							<svg-icon icon-class='g_home'/>
							<span>平台首页</span>
						</el-dropdown-item>
						<el-dropdown-item command='design'>
							<svg-icon icon-class='move'/>
							<span>设计小程序</span>
						</el-dropdown-item>
						<el-dropdown-item command='manage' >
							<svg-icon icon-class='g_default'/>
							<span>管理小程序</span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>

		</div>
		<el-dialog title="体验版二维码" :visible.sync="showCode" append-to-body	 width="20%" center>
			<div class="qrcodeImg">
				<img :src="Qrcode"  alt="">
			</div>
		</el-dialog>

		<el-dialog title="提交审核" :visible.sync="showsubAudit" append-to-body	 width="600px" center>
			<el-form label-width='100px'>
				<el-form-item label='所在服务类目'>
					<el-cascader expand-trigger="hover" style='width: 400px' :options="category_list" v-model="audit.classify">
					</el-cascader>
				</el-form-item>
				<div style="width: 400px;margin:-15px 0 20px 100px;font-size: 12px;color: #aaa;">功能页面和服务类目必须一一对应，且功能页面提供的内容必须符合该类目范围</div>
				<el-form-item label='标签'>
					<el-input style='width: 400px' v-model='audit.tag' placeholder='多个标签用空格隔开，可留空' size='small'/>
				</el-form-item>
				<el-form-item label=''>
					<el-button size='small' @click='showsubAudit=false'>取消</el-button>
					<el-button size='small'   @click='subAudit' type='primary'>提交审核</el-button>


				</el-form-item>
			</el-form>
		</el-dialog>

    <el-dialog title="修改密码" custom-class="passwordBox" width="600px" append-to-body :visible.sync="passBox">
      <el-form :model="form" label-width="80px">
        <el-form-item required label="旧密码">
          <el-input v-model="form.oldPassword" auto-complete="off" />
        </el-form-item>
        <el-form-item required label="新密码">
          <el-input v-model="form.newPassword" type="password" />
        </el-form-item>
        <el-form-item required label="确认密码">
          <el-input v-model="form.againPassword" type="password" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passBox = false">取 消</el-button>
        <el-button type="primary" @click="updatePass">确 定</el-button>
      </div>
    </el-dialog>
		<div class="rightbox">
			<div class="userbox">
				<el-dropdown @command="commandClick">
					<span class="userBlock">
						<svg-icon class='user' icon-class='user1' />
						<span style="margin-right: 10px">{{userName}}</span>
						<svg-icon class='bottom' icon-class='bottom' />
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command='editPass'>修改密码</el-dropdown-item>
						<el-dropdown-item command='logout' divided>退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="btnbox"  v-if='htmlon==0'>
				<el-button  size='small' type='' @click='saveApp(false)'>保存</el-button>
				<el-button  size='small' type='primary' @click='getQrCode'>保存并预览</el-button>
				<el-button size='small' v-if='app_info.status==1' disabled type='success' >审核中</el-button>
				<el-button size='small' v-else-if='app_info.status==0 || app_info.status==-1' @click='showsh' type='primary'>发布小程序</el-button>
				<el-button size='small' v-else-if='app_info.new_version != 0 && app_info.new_version!==app_info.user_version' @click='showsh' type='primary'>更新到 {{app_info.new_version}}</el-button>
				<el-button size='small' v-else-if='app_info.status==3' @click='showsh' type='primary'>发布小程序</el-button>
			</div>
		</div>
		<transition name="fade-selectTemp">
			<div class="showTemp" v-if='showTemp'>
				<div class="thead">
					<div class="tbox">
						<div class="left" @click='showTemp=false'>
							选择模板
						</div>
						<div class="right">
							<el-input size='medium' placeholder='搜索你想要的模板'>
								<el-button slot="append" icon="el-icon-search"></el-button>
							</el-input>
							<svg-icon class='close' icon-class='close'  @click.native='showTemp=false'/>
						</div>
					</div>
				</div>
				<div class="tcont">
					<div class="tbox"  v-loading='loadings'>
						<div class="tnav">
							<div @click='ChangeNav(item.id)' v-for='(item,index) in classify' class="li" :class='item.id == classifyon? "on":""'>{{item.title}}</div>
						</div>
						<div class="template">
							<div class="section" @mouseover='$set(item,"show",true)' @mouseout='item.show=false' v-for='(item,index) in list'>
								<img :src="item.img" alt="">
								<div class="btnbg" v-show='item.show'  @click='review(item)'>
									<div class="btn">预览</div>
								</div>
							</div>
						</div>
						<el-dialog  :visible.sync="showReview" width="950px" append-to-body>
							<div class="reviewbox">
								<div class="l__box">
									<img :src="reviewItem.big_img" alt="">
								</div>
								<div class="r__box">
									<img :src="url+'/template/get_qrcode?token='+token+'&app_id='+reviewItem.app_id">
									<p>请使用微信扫一扫查看</p>
								</div>
							</div>
							<span slot="footer" class="dialog-footer">
								<el-button @click="showReview = false">关闭</el-button>
								<el-button type="primary" @click="CreatApp">创建小程序</el-button>
							</span>
						</el-dialog>
					</div>
				</div>
			</div>
		</transition>
		<div class="consolebox" v-if='showConsole'>
			<div class="top">
				<el-button size='mini' @click='getConsoleConfig'>读取配置</el-button>
				<el-button type='primary' @click='saveConsoleConfig' size='mini'>保存</el-button>
			</div>
			<div class="bottom">
				<el-input type='textarea' v-model='consoleConfig' :autosize="{ minRows: 6, maxRows: 30}" />
			</div>
		</div>
	</div>
</template>
<script>
	import {getSite,getappConfig,saveConfig,addApp,editForms,submitCommit,getQrCode,getAuditStatus,subAudit,backAudit,getAudit,getTemplate,CreatApp,change_password,logout} from '@/api/api'
	import {getName,getToken,getWxappid,setWxappid} from '@/utils/auth'
	var p;
	export default{
		mounted(){
			console.log(p)
			if(this.$route.path.indexOf("/blocks/index") != -1){
				this.getAuditStatus()
			}
			this.getTemplate();
		},
		props:{
			// 0 :设计 1：管理 2 首页
			htmlon:{
				type:Number
			}
		},
		data(){
			return {

      passBox: false,
      form: {
        oldPassword: '',
        newPassword: '',
        againPassword: ''
      },
				history:[],
				url:getSite(),
				getWxappid:getWxappid(),
				token:getToken(),
				userName:getName(),
				showCode:false,
				Qrcode:"",
				showConsole:false,
				consoleConfig:'',
				showTemp:false,
				category_list:[],
				audit:{
					classify:[],
					tag:'',
				},
				auth:-1,
				authUrl:'',
				authInfo:{},
				app_info:{},
				showsubAudit:false,
				classify:[],
				classifyon:1,
				list:[],
				loadings:false,
				showReview:false,
				reviewItem:{}
			}
		},
		methods:{
			CreatApp(){
				if(!this.reviewItem.id){
					this.$message("请重新选择模板")
					return false
				}
				CreatApp({tid : this.reviewItem.app_id },this,res=>{
					setWxappid(res.data.new_id);

					this.$router.push({
						path:"/blocks/index/0",
						query:{wxappid:res.data.new_id}
					})
				})
			},
			review(item){
				this.showReview = true;
				this.reviewItem = item;
			},
			ChangeNav(id){
				this.classifyon = id;
				this.getTemplate();
			},
			getTemplate(){
				this.loadings = true;
				getTemplate({cid:this.classifyon},this,res=>{
					this.loadings = false;
					this.classify = res.data.classify;
					this.list = res.data.list;
				})
			},
			showsh(){
				this.getAudit();
				this.showsubAudit=true
			},
			getAuditStatus(){
				getAuditStatus(this,res=>{
					this.auth = res.data.authorization;
					if(res.data.authorization==0){
						this.authUrl = res.data.url
					}
					else{
						this.app_info = res.data.app_info
						this.authInfo = res.data.info
					}
				})
			},
			getAudit(){
				getAudit(this,res=>{
					var list = [];
					res.data.category_list.forEach(val=>{
						let issave = list.findIndex(fitem=>{
							return fitem.label == val.first_class
						})
						if(issave == -1){
							list.push({
								label:val.first_class,
								value:val.first_id+"@-@"+val.first_class,
								children:[]
							})
						}
					})
					res.data.category_list.forEach(val=>{
						list.forEach(fitem=>{
							if(fitem.label==val.first_class){

								let issave2 = fitem.children.findIndex(fitem1=>{
									return fitem1.label== val.second_class
								})
								if(issave2==-1){
									let temp = {
										label:val.second_class,
										value:val.second_id+"@-@"+val.second_class,
									}
									val.third_class? temp.children = [] :"";
									fitem.children.push(temp)
								}
							}
						})
					})
					if(res.data.category_list[0].third_class){
						res.data.category_list.forEach(val=>{
							list.forEach(fitem=>{
								if(fitem.label==val.first_class){
									fitem.children.forEach(fitem2=>{
										let issave3 = fitem2.children.findIndex(fitem3=>{
											return fitem3.label == val.third_class
										})
										if(issave3==-1){
											fitem2.children.push({
												label:val.third_class,
												value:val.third_id+"@-@"+val.third_class,
											})
										}
										console.log(issave3)
									})
								}
							})
						})

					}


					console.log(list)
					this.category_list = list
				})
			},
			subAudit(){
				if(this.audit.classify.length==0){
					this.$message.error("请选择所在服务类目");
					return false
				}
				if(this.ajax){
					return false
				}
				this.ajax= true;
				var f1 = this.audit.classify[0] || false;
				var f2 = this.audit.classify[1] || false;
				var f3 = this.audit.classify[2] || false;
				f1 = f1? f1.split("@-@") : "";
				f2 = f2? f2.split("@-@") : "";
				f3 = f3? f3.split("@-@") : "";

				var data = {
					first_class:f1[1],
					second_class:f2[1],
					third_class:f3[1],
					first_id: f1[0],
					second_id:f2[0],
					third_id:f3[0],
					tag:this.audit.tag
				}
				console.log(data)
				submitCommit(this,res=>{
					subAudit(data,this,res=>{
						if(res.data.status==-2){
							this.$message({
								type:'info',
								message:res.data.msg
							})
							this.ajax= false;
						}
						else{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							this.showsubAudit=false
						}
						console.log('here')
						this.ajax= false;
						this.getAuditStatus()
					})
				})
			},
			getConsoleConfig(){
				getappConfig(this,res=>{
					this.consoleConfig = res.data.info.configuration;
				})
			},
			saveConsoleConfig(){
				if(!this.consoleConfig){
					return false;
				}
				this.saveApp(false,this.consoleConfig)
			},
			addApp(){
				var info= {title:"新的小程序"};
				addApp(info,this,res=>{
					this.$message({
						type:'success',
						message:res.data.msg
					})
					this.$parent.getList()
				})
			},
			getQrCode(){
				this.saveApp(res=>{
					submitCommit(this,res=>{
						this.showCode = true;
						this.Qrcode = this.url+'/miniapp/get_qrcode?token='+this.token+'&app_id='+this.getWxappid+'&time='+Date.parse(new Date())
					})
				})
			},
			saveApp(fn=false,consoleConfig){
				p=window.$p;
				console.log(window.$p)
				this.$set(p.appConfig.appPage[p.appConfig.appPageon],'body',p.phoneData.body);
				if(consoleConfig){
					consoleConfig=JSON.parse(consoleConfig)
				}
				var config = consoleConfig? consoleConfig:p.appConfig;
				console.log(config);
				var willForms = [];
				config.appPage.forEach((page,index)=>{
					page.body.forEach((body,i)=>{
						if(body.tagName == "表单"){
							var has = willForms.findIndex((val)=>{
								return body.formid == val
							})
							if(has == -1) willForms.push({ form_id:body.formid})

						}
				})
				})
				willForms.forEach((v,f)=>{
					var formcontent = p.ajaxData.formsList.find((ct)=>{
						return v.form_id == ct.id
					})
					if(v.form_id != -1 && formcontent){
            console.log(v)
            console.log(formcontent)
						v.configuration = JSON.stringify(formcontent.configuration);
						editForms(v,this,res=>{
						})
					}
				})
				var json = JSON.stringify(config)
				saveConfig({id:1,configuration:json},this,res=>{
					this.$message({
						type:'success',
						message:res.data.msg
					})
					p.history = [];
					if(fn){
						fn()
					}
				})

				// console.log(json)
			},
			commandClick(command){
				if(command=='editPass'){
          this.passBox = true;
				}
				if(command=='logout'){
					logout(this,res=>{

					})
				}
				if(command=='home'){
					this.$router.push({
						path:'/'
					})
				}
				if(command=='design'){
					this.$router.push({
						path:'/blocks/index/0'
					})
				}
				if(command=='manage'){
					this.$router.push({
						path:'/manage/index'
					})
				}
			},

    updatePass() {
      var that = this
      var data = this.form
      if (data.oldPassword == '') {
        this.$message.error('请输入旧密码')
        return false
      } else if (data.newPassword == '') {
        this.$message.error('请输入新密码')
        return false
      } else if (data.newPassword.length < 6) {
        this.$message.error('密码长度不能低于6个字符')
        return false
      } else if (data.newPassword != data.againPassword) {
        this.$message.error('两次密码输入不一致')
        return false
      }
      change_password(data,this, res => {
        this.$message({
          type: 'success',
          message: res.data.msg
        })
        logout(this,res => {

        })
        this.passBox = false
      })
    },
		}
	}
</script>

<style lang="scss">
@import "@/styles/colors.scss";
.consolebox{
	width: 350px;
	position: fixed;
	top:80px;
	right: 20px;
	min-height: 200px;
	background: #fff;
	border-radius: 6px;
	box-shadow: 1px 1px 10px rgba(0,0,0,0.2);
	.top{
		display: flex;
		align-items: center;
		padding: 10px 10px 0 10px;
		justify-content: flex-end;
	}
	.bottom{
		padding: 10px;
	}
}
.qrcodeImg{
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 10px 20px 30px 20px;
}
.qrcodeImg img{
	width: 150px;
	height: 150px;
	background: #eee;
}
.userBlock:hover{
	color: $color1;
}
.addApp :hover{
	color: $color_dashed;
}
.topbar{
}
</style>

<style scoped>
.addApp{
	padding: 0 40px;
	font-size: 14px;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer
}
.addApp .ico{
	margin-right: 5px;
}
.dropbox{
	display: flex;
	padding: 0 20px;
}
.topbar{
	display: flex;
	justify-content: space-between;
	padding-right: 20px;
	align-items: center;
	z-index: 11;
}
.leftbox{
	height: 100%;
	display: flex;
	align-items: center;
	position: relative;
	z-index: 1;
}
.btnleft{
	width: 130px;
	display: inline-flex;
	align-items: center;
}
.userbox{
	height: 30px;
	display: flex;
	align-items: center;
	border-right: 1px solid #eee;
	margin: 0 20px;
}
.rightbox{
	display: flex;
}
.userBlock{
	width: 200px;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #888;
	transition: all .2s linear;
}


.userBlock:hover>.bottom{
	transform: rotate(180deg)
}
.userBlock .user{
	margin-right:6px;
	width: 22px;
	height: 22px;
}
.userBlock .bottom{
	width: 14px;
	height: 14px;
	transition: all .2s linear;
}
</style>



// WEBPACK FOOTER //
// src/views/laout/components/topBar.vue